import { DocumentationRequiredAction } from '@/components/modules/Documentation/components/DocumentationRequiredHeader/types/DocumentationRequiredAction';
import { documentationEditModeMapper } from '@/components/modules/Documentation/maps/documentationEditModeMapper';
import { DocumentationCapability } from '@/components/modules/Documentation/types/DocumentationCapability';
import { DocumentationMode } from '@/components/modules/Documentation/types/DocumentationMode';
import { Text } from '@/components/shared/components/Text';

export const useDocumentationRequiredHeaderActions = ({
  onClickAction,
}: {
  onClickAction: (action: DocumentationRequiredAction) => void;
}) => {
  const AddRequiredFile = {
    display: <Text tId={'ADD_REQUIRED_FILE_TYPE'} />,
    iconName: 'add',
    onClick: () => onClickAction(DocumentationRequiredAction.ADD_REQUIRED_FILE_TYPE_TO_DOCUMENTATION_REQUIRED),
  };

  const SetAreDocumentsConfirmed = {
    display: <Text tId={'SET_ARE_DOCUMENTS_CONFIRMED'} />,
    iconName: 'done',
    onClick: () => onClickAction(DocumentationRequiredAction.SET_ARE_DOCUMENTS_CONFIRMED),
  };

  const SendIncidenceNotification = {
    display: <Text tId={'SEND_INCIDENCE_NOTIFICATION'} />,
    iconName: 'email',
    onClick: () => onClickAction(DocumentationRequiredAction.SEND_INCIDENCE_NOTIFICATION),
  };

  const getActionOptionsArray = (editMode: DocumentationMode) => {
    const documentationCapabilities = documentationEditModeMapper(editMode);

    return documentationCapabilities
      .flatMap((capability) => {
        switch (capability) {
          case DocumentationCapability.EDIT_REQUIRED_DOCUMENTS:
            return AddRequiredFile;
          case DocumentationCapability.EDIT_DOCUMENT_STATUS:
            return SetAreDocumentsConfirmed;
          case DocumentationCapability.LENDER_SEND:
            return SendIncidenceNotification;
        }
      })
      .filter((el) => el !== undefined);
  };
  return { getActionOptionsArray };
};
